module.exports = __webpack_public_path__ + "images/khaleesi-f949eb6ceaf90ff4c04919724714f6e4.png";